import React, { useState, Suspense, lazy } from "react";
import { BrowserRouter as Router, Route, Switch } from "react-router-dom";
import { Provider } from "react-redux";

import { IonApp, IonButton } from "@ionic/react";
import "@ionic/core/css/core.css";
import "@ionic/core/css/ionic.bundle.css";

import styled from "styled-components";

import "./theme.css";
import isRedirected from "./utils/redirect";

// Export this for store functions to import
// export const remote_url = "https://holonext-ar-api.azurewebsites.net/api";

export const remote_url = "/api/v1";

const AcceptCookies = styled.div`
  position: absolute;
  bottom: 0;
  left: 0;
  width: 100%;
  height: 80px;
  background: #3880ff;
  display: flex;
  text-align: center;
  align-items: center;
  padding: 0 20px;
  color: white;
  justify-content: space-between;
  z-index: 9;
  @media (max-width: 550px) {
    height: unset;
    flex-direction: column;
  }
`;
const Text = styled.div`
  @media (max-width: 550px) {
    margin-right: 15px;
    padding-top: 15px;
    padding-bottom: 15px;
  }
`;
function App({ store }) {
  const [cookiesAccepted, setCookiesAccepted] = useState(false);
  isRedirected();
  return (
    <Provider store={store}>
      <Router>
        <IonApp>
          <Suspense fallback={<div>Loading...</div>}>
            <div>Welcome Holonext</div>
          </Suspense>
        </IonApp>
      </Router>
    </Provider>
  );
}

export default App;
